import { H1, H2 } from "@/components/ui/headings"
import { MainLayout } from "@/novus/layouts/MainLayout"
import CreateAccountForm from "@/novus/screens/onboarding/components/CreateAccountForm"
import React from "react"

const CreateAccountScreen = () => {
  return (
    <MainLayout showLogo={true}>
      <div className="mb-12">
        <H1>Create Your Hadley Account</H1>
        <H2>We just need some information to get started!</H2>
      </div>
      <CreateAccountForm />
    </MainLayout>
  )
}

export default CreateAccountScreen
